import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function FinalCTA() {
  return <section className="py-14 bg-zinc-950 relative border-t border-zinc-900" data-id="element-105">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-106">
        <FadeIn data-id="element-107">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-12 uppercase tracking-tight" data-id="element-108">
            UNA ÚLTIMA COSA ANTES DE DECIDIR
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-109">
          <p className="text-2xl text-white font-bold mb-8" data-id="element-110">
            Pensá en mañana a la mañana.
          </p>
          <p className="text-xl text-zinc-400 mb-12" data-id="element-111">
            ¿El monopatín va a arrancar sin problemas?
          </p>
          <p className="text-lg text-zinc-300 mb-12" data-id="element-112">
            Si la respuesta es probablemente sí pero nunca se sabe... tenés dos
            opciones.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 text-left mb-10" data-id="element-113">
          <FadeIn delay={0.3} direction="up" data-id="element-114">
            <div className="bg-zinc-900/50 p-8 rounded-xl border border-zinc-800 h-full" data-id="element-115">
              <h3 className="text-xl font-bold text-zinc-500 mb-4 uppercase" data-id="element-116">
                Opción 1:
              </h3>
              <p className="text-zinc-400" data-id="element-117">
                Seguir haciendo lo que hacías. La búsqueda en Google de 40
                minutos. El service con turno en 5 días. Los $40.000 por una
                reparación simple. El ciclo que empieza de nuevo cada vez que
                algo falla.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} direction="up" data-id="element-118">
            <div className="bg-zinc-900/80 p-8 rounded-xl border border-brand-red/30 h-full relative overflow-hidden" data-id="element-119">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-red/5 blur-[40px] rounded-full" data-id="element-120"></div>
              <h3 className="text-xl font-bold text-white mb-4 uppercase relative z-10" data-id="element-121">
                Opción 2:
              </h3>
              <p className="text-zinc-300 relative z-10" data-id="element-122">
                Tener el sistema completo. El protocolo exacto para cada falla.
                El diagnóstico en 60 segundos. El plan de mantenimiento semanal
                para que no vuelva a pasar. Y si elegís el Pack Completo, el
                directorio de repuestos para nunca pagar de más y la agenda de
                12 meses para no olvidarte nada.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.5} data-id="element-123">
          <p className="text-2xl md:text-3xl text-white font-bold mb-4" data-id="element-124">
            Una sola visita al service cuesta más que el Pack Completo.
          </p>
          <p className="text-xl text-zinc-400 mb-10" data-id="element-125">
            Y esa visita te resuelve un problema. El Master Pack te resuelve
            todos los que van a venir.
          </p>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-126">
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 md:p-12 max-w-2xl mx-auto" data-id="element-127">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center justify-center gap-3" data-id="element-128">
              <span className="w-3 h-3 rounded-full animate-pulse bg-[#5DF300]" data-id="element-129"></span>
              ELEGÍ TU OPCIÓN:
            </h3>

            <div className="space-y-6" data-id="element-130">
              <div className="text-left" data-id="element-131">
                <p className="text-sm font-bold text-zinc-500 mb-2 uppercase" data-id="element-132">
                  OPCIÓN A — PACK COMPLETO RECOMENDADO
                </p>
                <p className="text-white font-bold mb-1" data-id="element-133">
                  MASTER PACK: REPARACIÓN EXPRESS + Mantenimiento Preventivo
                  Express
                </p>
                <p className="text-zinc-400 line-through text-sm inline-block mr-2" data-id="element-134">
                  $36.990
                </p>
                <p className="font-bold inline-block text-[#F3CE00]" data-id="element-135">
                  $29.990 ARS
                </p>

                <a href="https://fegion.shop/cart/46210825814155:1" className="mt-4 w-full block text-center py-5 px-6 hover:bg-[#4CD200] text-white font-bold rounded-xl transition-colors uppercase tracking-wide text-lg shadow-[0_0_20px_rgba(93,243,0,0.3)] bg-[#5DF300]" data-id="element-136">
                  → SÍ, QUIERO EL PACK COMPLETO ←
                </a>
                <p className="text-center text-sm text-zinc-400 mt-3" data-id="element-137">
                  ✅ Todo incluido · ✅ Acceso inmediato · ✅ Garantía 7 días
                </p>
              </div>

              <div className="py-4 text-zinc-600 font-bold uppercase" data-id="element-138">
                — o —
              </div>

              <div className="text-left bg-zinc-950 p-6 rounded-xl border border-zinc-800/50" data-id="element-139">
                <p className="text-sm font-bold text-zinc-500 mb-2 uppercase" data-id="element-140">
                  OPCIÓN B — Solo el Pack Base
                </p>
                <p className="text-white font-bold mb-4" data-id="element-141">$19.990 ARS</p>

                <a href="https://fegion.shop/cart/46210815328395:1" className="w-full block text-center py-3 px-6 font-medium rounded-xl border border-zinc-700 text-[#FFFFFF] bg-[#D55C00]" data-id="element-142">
                  No gracias, prefiero solo los 5 Tomos y 2 Bonos
                </a>
              </div>
            </div>
          </div>

          <p className="text-xl md:text-2xl text-white font-bold mt-10 mb-6" data-id="element-143">
            ¿Cuántas veces más vas a quedar tirado esperando que alguien venga a
            rescatarte?
          </p>

          <div className="space-y-4 max-w-xl mx-auto" data-id="element-144">
            <a href="https://fegion.shop/cart/46210825814155:1" className="w-full block text-center py-4 px-6 hover:bg-[#4CD200] text-white font-bold rounded-xl transition-colors uppercase tracking-wide shadow-[0_0_20px_rgba(93,243,0,0.3)] bg-[#5DF300]" data-id="element-145">
              → SÍ, QUIERO EL PACK COMPLETO — $29.990 ARS ←
            </a>
            <a href="https://fegion.shop/cart/46210815328395:1" className="w-full block text-center py-3 px-6 text-zinc-400 font-medium underline decoration-zinc-700 underline-offset-4" data-id="element-146">
              No gracias, prefiero solo el Pack Base — $19.990 ARS
            </a>
          </div>

          <p className="text-sm text-zinc-500 mt-8 uppercase tracking-widest" data-id="element-147">
            Pago único · Acceso inmediato · 100% Digital · Garantía 7 días
          </p>
        </FadeIn>
      </div>
    </section>;
}